(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["akb-breadcrumbs"] && !Shopify.designMode) return;
  try {
    // Category pages remember themselves so a product opened from one reads
  // "Home / Category / Product" instead of the generic "Home / Equipment".
  (function () {
    var STORAGE_KEY = 'akb:breadcrumb-trail';

    function readTrail() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (error) {
        return null;
      }
    }

    function writeTrail(trail) {
      try {
        if (trail) {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trail));
        } else {
          sessionStorage.removeItem(STORAGE_KEY);
        }
      } catch (error) {
        // Storage is unavailable in private browsing; the server-rendered crumb stands.
      }
    }

    // The trail only applies when the visitor actually arrived from that listing,
    // or is still moving between products reached from it (related equipment).
    function arrivedFrom(href) {
      if (!document.referrer) return false;

      var from;
      try {
        from = new URL(document.referrer, window.location.origin);
      } catch (error) {
        return false;
      }

      if (from.origin !== window.location.origin) return false;
      if (from.pathname + from.search === href) return true;
      return from.pathname.indexOf('/products/') !== -1;
    }

    document.querySelectorAll('[data-akb-breadcrumbs]').forEach(function (nav) {
      var source = nav.getAttribute('data-akb-crumb-source');

      if (source) {
        writeTrail({ label: source, href: window.location.pathname + window.location.search });
        return;
      }

      var crumb = nav.querySelector('[data-akb-crumb-parent] a');
      if (!crumb) return;

      var trail = readTrail();
      if (!trail || !trail.label || !trail.href) return;

      if (!arrivedFrom(trail.href)) {
        writeTrail(null);
        return;
      }

      crumb.textContent = trail.label;
      crumb.setAttribute('href', trail.href);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["akb-phone-field"] && !Shopify.designMode) return;
  try {
    (function () {
    const ALLOWED = /^[0-9+()\-.\s]+$/;

    function messageFor(input) {
      const value = input.value.trim();
      if (value === '') return '';
      if (!ALLOWED.test(value)) return input.dataset.phoneError;
      const digits = value.replace(/\D/g, '');
      if (digits.length < 7 || digits.length > 15) return input.dataset.phoneShort;
      return '';
    }

    function render(input, message) {
      const box = document.getElementById(input.getAttribute('aria-describedby'));
      input.setCustomValidity(message);
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (box) {
        box.textContent = message;
        box.hidden = message === '';
      }
    }

    function bind(input) {
      if (input.dataset.phoneBound === 'true') return;
      input.dataset.phoneBound = 'true';

      input.addEventListener('blur', function () {
        render(input, messageFor(input));
      });

      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') !== 'true') {
          input.setCustomValidity('');
          return;
        }
        render(input, messageFor(input));
      });

      const form = input.form;
      if (form && form.dataset.phoneBound !== 'true') {
        form.dataset.phoneBound = 'true';
        form.addEventListener(
          'submit',
          function (event) {
            const message = messageFor(input);
            render(input, message);
            if (message) {
              event.preventDefault();
              event.stopPropagation();
              input.focus();
            }
          },
          true
        );
      }
    }

    function init() {
      document.querySelectorAll('[data-akb-phone]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["akb-product-listing"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-akb-collection]').forEach((section) => {
    const form = section.querySelector('[data-akb-filter-form]');
    const sort = section.querySelector('[data-akb-sort]');
    const panel = section.querySelector('[data-akb-filters]');
    const toggle = section.querySelector('[data-akb-filters-toggle]');

    // Sorting applies immediately, filters wait for the "Apply filters" button.
    if (form && sort) {
      sort.addEventListener('change', () => form.requestSubmit());
    }

    if (form && panel) {
      form.addEventListener('change', (event) => {
        if (event.target === sort) return;
        panel.classList.add('filters--dirty');
      });
    }

    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = panel.classList.toggle('filters--open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // "Show all" / "Show less" for long option lists.
    section.querySelectorAll('[data-akb-filter-more]').forEach((more) => {
      const list = more.parentElement.querySelector('[data-akb-filter-options]');
      if (!list) return;

      more.addEventListener('click', () => {
        const expanded = more.getAttribute('aria-expanded') === 'true';
        more.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        list.classList.toggle('fopts--collapsed', expanded);
      });
    });

    // Type-ahead within a long option list (filters the checkboxes, not the products).
    section.querySelectorAll('[data-akb-filter-search]').forEach((input) => {
      const body = input.closest('.fgroup__body');
      const list = body && body.querySelector('[data-akb-filter-options]');
      if (!list) return;

      const options = Array.from(list.querySelectorAll('.fopt'));
      const empty = list.querySelector('.fopts__empty');
      const more = body.querySelector('[data-akb-filter-more]');

      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let matches = 0;

        options.forEach((option) => {
          const label = (option.dataset.label || '').toLowerCase();
          const hit = query === '' || label.indexOf(query) !== -1;
          option.hidden = !hit;
          if (hit) matches += 1;
        });

        // While searching, show every match instead of the truncated list.
        list.classList.toggle('fopts--collapsed', query === '' && (!more || more.getAttribute('aria-expanded') !== 'true'));
        if (more) more.hidden = query !== '';
        if (empty) empty.hidden = matches !== 0;
      });
    });

    // Price shortcuts write into the min/max inputs so they submit as real filters.
    section.querySelectorAll('[data-akb-price-buckets]').forEach((buckets) => {
      const body = buckets.closest('.fgroup__body');
      const min = body && body.querySelector('[data-akb-price-min]');
      const max = body && body.querySelector('[data-akb-price-max]');
      if (!min || !max) return;

      const options = Array.from(buckets.querySelectorAll('[data-akb-price-bucket]'));

      const same = (a, b) => {
        if (a === '' || b === '') return a === '' && b === '';
        return Math.abs(parseFloat(a) - parseFloat(b)) < 0.005;
      };

      const sync = () => {
        options.forEach((option) => {
          const hit = same(option.dataset.min, min.value) && same(option.dataset.max, max.value);
          option.classList.toggle('fbucket--active', hit);
          option.setAttribute('aria-pressed', hit ? 'true' : 'false');
        });
      };

      options.forEach((option) => {
        option.addEventListener('click', () => {
          min.value = option.dataset.min;
          max.value = option.dataset.max;
          sync();
          if (panel) panel.classList.add('filters--dirty');
        });
      });

      min.addEventListener('input', sync);
      max.addEventListener('input', sync);
      sync();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
